var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPolice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.661,
    x2: 258.661,
    y1: 19.883,
    y2: 138.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.287,
    x2: 142.287,
    xlinkHref: "#lg1",
    y1: 57.092,
    y2: 124.229
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.323,
    x2: 195.323,
    xlinkHref: "#lg1",
    y1: 57.092,
    y2: 124.229
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.74,
    x2: 248.74,
    xlinkHref: "#lg1",
    y1: 57.092,
    y2: 124.229
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.651,
    x2: 282.651,
    xlinkHref: "#lg1",
    y1: 57.092,
    y2: 124.229
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.047,
    x2: 323.047,
    xlinkHref: "#lg1",
    y1: 57.092,
    y2: 124.229
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.465,
    x2: 376.465,
    xlinkHref: "#lg1",
    y1: 57.092,
    y2: 124.229
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.467,
    x2: 262.583,
    xlinkHref: "#lg2",
    y1: 188.667,
    y2: 262.063
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.661,
    x2: 258.661,
    xlinkHref: "#lg3",
    y1: 237.72,
    y2: 174.994
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.856,
    x2: 132.856,
    xlinkHref: "#lg1",
    y1: 221.51,
    y2: 253.384
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.726,
    x2: 216.726,
    xlinkHref: "#lg1",
    y1: 221.51,
    y2: 253.384
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.596,
    x2: 300.596,
    xlinkHref: "#lg1",
    y1: 221.51,
    y2: 253.384
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.466,
    x2: 384.466,
    xlinkHref: "#lg1",
    y1: 221.51,
    y2: 253.384
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.46,
    x2: 261.503,
    xlinkHref: "#lg1",
    y1: 147.636,
    y2: 196.16
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.661,
    x2: 258.661,
    xlinkHref: "#lg4",
    y1: 184.972,
    y2: 141.224
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4428,
    stopColor: "#c1aec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 126.862,
    y2: 163.368
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.661,
    x2: 258.661,
    xlinkHref: "#lg1",
    y1: 290.637,
    y2: 481.58
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.388,
    x2: -6.173,
    xlinkHref: "#lg4",
    y1: 445.071,
    y2: 213.51
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.52,
    x2: 182.596,
    xlinkHref: "#lg1",
    y1: 405.516,
    y2: 373.362
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.835,
    x2: 202.505,
    xlinkHref: "#lg2",
    y1: 409.615,
    y2: 385.893
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.1,
    x2: 229.633,
    xlinkHref: "#lg3",
    y1: 394.885,
    y2: 382.79
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.012,
    x2: 317.267,
    xlinkHref: "#lg4",
    y1: 419.056,
    y2: 266.31
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.966,
    x2: 264.21,
    xlinkHref: "#lg2",
    y1: 442.472,
    y2: 534.915
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.053,
    x2: 202.129,
    xlinkHref: "#lg5",
    y1: 293.736,
    y2: 421.812
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.256,
    x2: 25.735,
    xlinkHref: "#lg5",
    y1: 379.717,
    y2: 283.249
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.405,
    x2: 98.405,
    xlinkHref: "#lg6",
    y1: 370.68,
    y2: 299.384
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.341,
    x2: 123.341,
    xlinkHref: "#lg6",
    y1: 370.68,
    y2: 299.384
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.277,
    x2: 148.277,
    xlinkHref: "#lg6",
    y1: 370.68,
    y2: 299.384
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.693,
    x2: 472.768,
    xlinkHref: "#lg5",
    y1: 293.736,
    y2: 421.812
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.895,
    x2: 296.375,
    xlinkHref: "#lg5",
    y1: 379.717,
    y2: 283.249
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.045,
    x2: 369.045,
    xlinkHref: "#lg6",
    y1: 370.68,
    y2: 299.384
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.98,
    x2: 393.98,
    xlinkHref: "#lg6",
    y1: 370.68,
    y2: 299.384
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.916,
    x2: 418.916,
    xlinkHref: "#lg6",
    y1: 370.68,
    y2: 299.384
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.661,
    x2: 258.661,
    y1: 98.348,
    y2: -10.624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.661,
    x2: 258.661,
    xlinkHref: "#lg1",
    y1: 0.559,
    y2: 25.676
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m92.013 19.883h333.296v118.424h-333.296z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m118.393 48.429c0-2.385 2.194-4.483 5.532-4.483h19.745c12.591 0 22.511 5.914 22.511 21.939v.477c0 16.025-10.302 22.129-23.465 22.129h-9.443v20.604c0 3.052-3.72 4.579-7.44 4.579s-7.44-1.526-7.44-4.579zm14.88 8.489v20.127h9.443c5.341 0 8.585-3.052 8.585-9.539v-1.049c0-6.486-3.243-9.538-8.585-9.538h-9.443z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.905 91.734v-25.278c0-16.406 10.206-22.511 23.37-22.511 13.163 0 23.465 6.105 23.465 22.511v25.278c0 16.406-10.302 22.511-23.465 22.511-13.164 0-23.37-6.105-23.37-22.511zm31.955-25.278c0-6.581-3.243-9.538-8.585-9.538-5.341 0-8.489 2.957-8.489 9.538v25.278c0 6.581 3.148 9.538 8.489 9.538 5.342 0 8.585-2.957 8.585-9.538z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.766 113.673c-3.243 0-6.486-1.526-6.486-4.579v-60.665c0-3.148 3.72-4.483 7.44-4.483s7.44 1.336 7.44 4.483v52.271h21.748c2.862 0 4.292 3.243 4.292 6.486s-1.431 6.486-4.292 6.486h-30.142z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.211 48.429c0-3.148 3.72-4.483 7.44-4.483s7.44 1.336 7.44 4.483v60.666c0 3.052-3.72 4.579-7.44 4.579s-7.44-1.526-7.44-4.579z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.095 56.918c-5.437 0-8.585 3.052-8.585 9.538v25.278c0 6.486 3.148 9.538 8.68 9.538 7.631 0 8.108-5.819 8.394-9.538.286-3.53 3.53-4.483 7.345-4.483 5.151 0 7.535 1.336 7.535 7.059 0 12.687-10.302 19.936-23.942 19.936-12.496 0-22.893-6.105-22.893-22.511v-25.279c0-16.406 10.397-22.511 22.893-22.511 13.64 0 23.942 6.868 23.942 18.982 0 5.723-2.385 7.059-7.44 7.059-4.006 0-7.249-1.049-7.44-4.483-.096-2.48-.382-8.585-8.489-8.585z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.882 73.038h14.308c2.861 0 4.483 2.766 4.483 5.819 0 2.575-1.336 5.628-4.483 5.628h-14.308v16.215h25.563c2.861 0 4.483 3.052 4.483 6.582 0 3.052-1.335 6.391-4.483 6.391h-33.958c-3.243 0-6.486-1.526-6.486-4.579v-60.57c0-3.052 3.243-4.579 6.486-4.579h33.958c3.148 0 4.483 3.339 4.483 6.391 0 3.53-1.622 6.582-4.483 6.582h-25.563z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64.99 169.419h387.34v91.142h-387.34z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.99 169.419v19.716l71.425 71.426h315.916v-91.142z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m125.455 175.809h14.801v95.851h-14.801z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.325 175.809h14.801v95.851h-14.801z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.195 175.809h14.801v95.851h-14.801z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.065 175.809h14.801v95.851h-14.801z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m459.036 189.136h-400.751c-3.79 0-6.862-3.072-6.862-6.862v-40.743h414.475v40.743c0 3.789-3.072 6.862-6.862 6.862z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.423 141.531v14.668l32.937 32.937h374.676c3.79 0 6.862-3.072 6.862-6.862v-40.743z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.33 156.199h-414.66c-8.101 0-14.668-6.567-14.668-14.668 0-8.101 6.567-14.668 14.668-14.668h414.66c8.101 0 14.668 6.567 14.668 14.668 0 8.101-6.567 14.668-14.668 14.668z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m459.036 256.724h-400.751c-3.79 0-6.862 3.072-6.862 6.862v214.727h414.475v-214.727c0-3.789-3.072-6.862-6.862-6.862z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.617 295.712c-.338-2.605-2.54-3.624-5.237-3.624h-76.078c-2.93 0-4.305 1.375-4.305 4.305v93.262c0 2.697 1.019 4.9 3.624 5.237l83.421 83.421h181.176z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m328.435 478.313h-139.549v-169.684c0-9.688 7.854-17.542 17.542-17.542h104.464c9.688 0 17.542 7.854 17.542 17.542v169.684z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.599 478.313h-97.878v-155.689c0-6.8 5.513-12.313 12.313-12.313h73.251c6.8 0 12.313 5.513 12.313 12.313v155.689z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.661 478.313h48.939v-155.689c0-6.8-5.513-12.313-12.313-12.313h-36.626z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m465.898 324.353-28.642-28.642c-.338-2.605-2.54-3.624-5.237-3.624h-76.078c-2.93 0-4.305 1.375-4.305 4.305v93.262c0 2.697 1.019 4.9 3.624 5.237l83.421 83.421h27.217z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.288 510h-399.255c-10.333 0-18.71-8.377-18.71-18.71v-23.734c0-10.333 8.377-18.71 18.71-18.71h399.255c10.333 0 18.71 8.377 18.71 18.71v23.734c0 10.333-8.377 18.71-18.71 18.71z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m161.38 394.961h-76.078c-2.93 0-5.306-2.375-5.306-5.306v-93.262c0-2.93 2.375-5.306 5.306-5.306h76.078c2.93 0 5.306 2.375 5.306 5.306v93.262c-.001 2.93-2.376 5.306-5.306 5.306z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.964 389.107h-67.247c-2.595 0-4.699-2.104-4.699-4.699v-82.766c0-2.595 2.104-4.699 4.699-4.699h67.247c2.595 0 4.699 2.104 4.699 4.699v82.766c.001 2.595-2.103 4.699-4.699 4.699z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.589 383.463h-8.367c-2.018 0-3.653-1.636-3.653-3.653v-73.571c0-2.018 1.636-3.653 3.653-3.653h8.367c2.018 0 3.653 1.636 3.653 3.653v73.571c0 2.017-1.636 3.653-3.653 3.653z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.524 383.463h-8.367c-2.018 0-3.653-1.636-3.653-3.653v-73.571c0-2.018 1.636-3.653 3.653-3.653h8.367c2.018 0 3.653 1.636 3.653 3.653v73.571c.001 2.017-1.635 3.653-3.653 3.653z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.46 383.463h-8.367c-2.018 0-3.653-1.636-3.653-3.653v-73.571c0-2.018 1.636-3.653 3.653-3.653h8.367c2.018 0 3.653 1.636 3.653 3.653v73.571c.001 2.017-1.635 3.653-3.653 3.653z",
    fill: "url(#SVGID_28_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m432.019 394.961h-76.078c-2.93 0-5.306-2.375-5.306-5.306v-93.262c0-2.93 2.375-5.306 5.306-5.306h76.078c2.93 0 5.306 2.375 5.306 5.306v93.262c0 2.93-2.376 5.306-5.306 5.306z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.604 389.107h-67.247c-2.595 0-4.699-2.104-4.699-4.699v-82.766c0-2.595 2.104-4.699 4.699-4.699h67.247c2.595 0 4.699 2.104 4.699 4.699v82.766c0 2.595-2.104 4.699-4.699 4.699z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m373.228 383.463h-8.367c-2.018 0-3.653-1.636-3.653-3.653v-73.571c0-2.018 1.636-3.653 3.653-3.653h8.367c2.018 0 3.653 1.636 3.653 3.653v73.571c.001 2.017-1.635 3.653-3.653 3.653z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.164 383.463h-8.367c-2.018 0-3.653-1.636-3.653-3.653v-73.571c0-2.018 1.636-3.653 3.653-3.653h8.367c2.018 0 3.653 1.636 3.653 3.653v73.571c0 2.017-1.635 3.653-3.653 3.653z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.1 383.463h-8.367c-2.018 0-3.653-1.636-3.653-3.653v-73.571c0-2.018 1.636-3.653 3.653-3.653h8.367c2.018 0 3.653 1.636 3.653 3.653v73.571c0 2.017-1.636 3.653-3.653 3.653z",
    fill: "url(#SVGID_33_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m92.013 19.883v9.647l.603-.193 108.971 108.97h223.721v-118.424z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.705 29.337h-332.089c-8.101 0-14.668-6.567-14.668-14.668 0-8.102 6.567-14.669 14.668-14.669h332.089c8.101 0 14.668 6.567 14.668 14.668 0 8.101-6.567 14.669-14.668 14.669z",
    fill: "url(#SVGID_35_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolice);
export default __webpack_public_path__ + "static/media/icon-police.932b01e137c9681d56609e634affa50e.svg";
export { ForwardRef as ReactComponent };